import React from 'react';

interface DecimalFieldProps {
    id: string;
    value: string | number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    disabled?: boolean;
    min?: number;
    max?: number;
    step?: number;
    decimalPlaces?: number;
}

const DecimalField: React.FC<DecimalFieldProps> = ({
    id,
    value,
    onChange,
    placeholder,
    disabled,
    min,
    max,
    step = 0.0000001,
    decimalPlaces = 7,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;

        if (inputValue === '' || inputValue === '-') {
            onChange(e);
            return;
        }

        const decimalRegex = /^-?\d*\.?\d*$/;
        if (decimalRegex.test(inputValue)) {
            const parts = inputValue.split('.');
            if (parts.length === 2 && parts[1].length > decimalPlaces) {
                return;
            }

            const numValue = parseFloat(inputValue);
            if (!Number.isNaN(numValue)) {
                if (
                    (min !== undefined && numValue < min) ||
                    (max !== undefined && numValue > max)
                ) {
                    return;
                }
            }

            onChange(e);
        }
    };

    return (
        <input
            type="text"
            id={id}
            value={value ?? ''}
            onChange={handleChange}
            placeholder={placeholder}
            className="h-10 w-full rounded border border-slate-200 px-4 text-sm text-slate-500 dark:border-seam
        dark:bg-graphite dark:text-cream outline-none transition-all focus:border-secondary dark:focus:border-secondary"
            disabled={disabled}
            inputMode="decimal"
            data-type="decimal"
            step={step}
        />
    );
};

export default DecimalField;
